import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import ImageIcon from 'components/ImageIcon';

import css from './InfographicsCard.module.scss';

class InfographicsCard extends React.PureComponent {
    static propTypes = {
        "number": PropTypes.string.isRequired,
        "unit": PropTypes.string,
        "description": PropTypes.string,
        "icon": PropTypes.string.isRequired,
        "iconNew": PropTypes.string.isRequired
    }

    render() {
        const {
            number,
            unit,
            description,
            icon,
            iconNew,
        } = this.props;

        const numberFormatted = number && <strong>{number}</strong>;
        const unitFormatted = unit && <strong>{unit}</strong>;

        return (
            <div className={css.card}>
                {iconNew ? (
                    <ImageIcon {...iconNew} />
                ) : 
                    (icon ? (
                        <Icon icon={icon} />
                    ) : null)
                }
                <div className={css.text}>
                    {numberFormatted}{unitFormatted}{` ${description}`}
                </div>
            </div>
        );
    }
}

export default InfographicsCard;



// WEBPACK FOOTER //
// ./src/components/InfographicsCard/InfographicsCard.jsx